import {requestJson} from './api.ts';
import type {IItemInstanceDTO, PendingLootDTO, QuestDTO} from '@hexcrawl/shared-utils';

export interface ClaimLootResult {
  inventory: IItemInstanceDTO[];
  skipped: number;
  gold: number;
  food: number;
  pendingLoot?: PendingLootDTO;
  promotedQuests?: QuestDTO[];
}

export interface ClaimItemResult {
  inventory: IItemInstanceDTO[];
  gold: number;
  food: number;
  pendingLoot?: PendingLootDTO;
  promotedQuests?: QuestDTO[];
}

export const lootApiService = {
  claimLoot(gameId: string): Promise<ClaimLootResult> {
    return requestJson<ClaimLootResult>({
      url: '/game/loot/claim',
      method: 'POST',
      data: { gameId },
    });
  },

  claimItem(gameId: string, index: number): Promise<ClaimItemResult> {
    return requestJson<ClaimItemResult>({
      url: '/game/loot/claim-item',
      method: 'POST',
      data: { gameId, index },
    });
  },

  dismissLoot(gameId: string): Promise<void> {
    return requestJson<void>({
      url: '/game/loot/dismiss',
      method: 'POST',
      data: { gameId },
    });
  },
};
